<template>
  <div id="member-subscription-create">
    <v-card class="modern-header slide-up-animation" elevation="2">
      <v-card-title class="modern-card-title pa-0">
        <!-- Floating Bubbles Background -->
        <ul class="bg-bubbles">
          <li v-for="n in 10" :key="n"></li>
        </ul>
        <div class="header-left">
          <v-icon class="mr-4 flying-icon" size="52" color="#ffffff"
            >mdi-credit-card-outline</v-icon
          >
          <div class="title-content">
            <h1 class="page-title">Offline Subscription Payment</h1>
            <p class="page-subtitle">
              Process and manage offline payment transactions for member
              subscriptions
            </p>
          </div>
        </div>
        <v-spacer />
        <div class="header-actions">
          <v-btn
            @click.prevent="pageData"
            icon
            color="#ffffff"
            class="action-btn"
            v-tooltip="'Refresh Data'"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-container class="notes modern-notes" v-if="NotesFlag">
          <v-icon class="mr-2" small color="#FF6B6B"
            >mdi-information-outline</v-icon
          >
          <span class="notes-title">Important Notes:</span>
          <ol class="notes-list">
            <li>
              <v-icon x-small class="mr-1">mdi-check-circle</v-icon>Regular
              subscription can be paid only once.
            </li>
            <li>
              <v-icon x-small class="mr-1">mdi-check-circle</v-icon>After paying
              regular subscription, choose additional subscription.
            </li>
            <li>
              <v-icon x-small class="mr-1">mdi-check-circle</v-icon>Late fee is
              optional but paying late fee is required to get voting rights.
            </li>
            <li>
              <v-icon x-small class="mr-1">mdi-check-circle</v-icon>After
              completing the payment, kindly select your members for whom the
              payment was made.
            </li>
          </ol>
        </v-container>
        <br />
        <div class="d-flex justify-content-end mb-4">
          <div class="required-pill">
            <span class="required-star">*</span>
            <span class="required-text">Indicates required fields</span>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-container v-if="StartupLoadingFlag">
          <v-row wrap>
            <v-col cols="12" md="4" v-for="n in 6" :key="n">
              <v-skeleton-loader
                v-bind="attrs"
                type="paragraph"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
        <v-form ref="form2" v-model="valid1" lazy-validation>
          <v-container v-if="!StartupLoadingFlag">
            <v-card
              class="form-section form-section-org slide-up-animation delay-100"
              elevation="1"
            >
              <div class="card-bubbles-container">
                <div class="card-bubble" v-for="n in 5" :key="n"></div>
              </div>
              <v-card-title class="section-title">
                <v-icon class="section-icon-wrapper" color="#3A67B1"
                  >mdi-office-building</v-icon
                >
                Organization & Member Details
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-6">
                <v-row wrap>
                  <v-col cols="12" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span> Year
                    </label>
                    <v-autocomplete
                      @change="getZoneCodeOptions"
                      :reduce="(option) => option.value"
                      :loading="JciYearCodeOptionsLoading"
                      :items="JciYearCodeOptions"
                      :rules="JciYearCodeRules"
                      v-model="JciYearCode"
                      dense
                      clearable
                      required
                      outlined
                      rounded
                      prepend-inner-icon="mdi-calendar"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span> LO Type
                    </label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="LomTypeOptionsLoading"
                      :items="LomTypeOptions"
                      :rules="LomTypeRules"
                      v-model="LomType"
                      dense
                      clearable
                      required
                      outlined
                      rounded
                      prepend-inner-icon="mdi-account-group"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span> Zone
                    </label>
                    <v-autocomplete
                      @change="getLomCodeOptions"
                      :reduce="(option) => option.value"
                      :loading="ZoneCodeOptionsLoading"
                      :items="ZoneCodeOptions"
                      :rules="ZoneCodeRules"
                      v-model="ZoneCode"
                      dense
                      clearable
                      required
                      outlined
                      rounded
                      prepend-inner-icon="mdi-earth"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span> LO
                    </label>
                    <v-autocomplete
                      @change="getMemberDetails"
                      :reduce="(option) => option.value"
                      :loading="LomCodeOptionsLoading"
                      :items="LomCodeOptions"
                      :rules="LomCodeRules"
                      v-model="LomCode"
                      dense
                      clearable
                      required
                      outlined
                      rounded
                      prepend-inner-icon="mdi-domain"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card
              class="form-section form-section-location mt-6 slide-up-animation delay-200"
              elevation="1"
            >
              <div class="card-bubbles-container">
                <div class="card-bubble" v-for="n in 5" :key="n"></div>
              </div>
              <v-card-title class="section-title">
                <v-icon class="section-icon-wrapper" color="#c31432"
                  >mdi-map-marker-multiple</v-icon
                >
                Location & Contact Details
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-6">
                <v-row wrap>
                  <v-col cols="12" sm="6" md="3">
                    <h6 class="field-label">
                      <span class="text-danger">*</span> State Of LO
                    </h6>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="StateCodeOptionsLoading"
                      :items="StateCodeOptions"
                      :rules="StateCodeRules"
                      v-model="StateCode"
                      required
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-map"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <h6 class="field-label">
                      <span class="text-danger">*</span> District Of LO
                    </h6>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="DistrictCodeOptionsLoading"
                      :items="DistrictCodeOptions"
                      :rules="DistrictCodeRules"
                      v-model="DistrictCode"
                      required
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-city"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <h6 class="field-label">
                      <span class="text-danger">*</span> City Of LO
                    </h6>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="CityCodeOptionsLoading"
                      :items="CityCodeOptions"
                      :rules="CityCodeRules"
                      v-model="CityCode"
                      dense
                      clearable
                      required
                      outlined
                      rounded
                      prepend-inner-icon="mdi-map-marker"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label
                      class="field-label"
                      v-if="!MemberFlag && LomType == 1"
                    >
                      <span class="text-danger">*</span> New Member Name
                    </label>
                    <label class="field-label" v-else>
                      <span class="text-danger">*</span> President Name
                    </label>
                    <v-row v-if="!MemberFlag && LomType == 1">
                      <v-col cols="12">
                        <v-text-field
                          v-model="MemberName"
                          :rules="MemberNameRules"
                          type="text"
                          hint="Enter Member Name"
                          dense
                          outlined
                          rounded
                          prepend-inner-icon="mdi-account"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="!MemberFlag && LomType == 2">
                      <v-col cols="12">
                        <h4 class="text-danger info-text">NA</h4>
                      </v-col>
                    </v-row>
                    <v-row v-if="MemberFlag">
                      <v-col cols="3">
                        <v-img
                          :src="Member.MemberImagePath"
                          :alt="Member.MemberName"
                          lazy-src="/no-image-available.png"
                          max-width="50"
                          max-height="50"
                          class="member-image-small"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-col>
                      <v-col cols="9">
                        <h4 class="info-text">{{ Member.MemberName }}</h4>
                        <h5 class="info-subtext">{{ Member.MembershipId }}</h5>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-if="!MemberFlag && LomType == 1"
                  >
                    <label class="field-label">
                      <span class="text-danger">*</span> Mobile Number
                    </label>
                    <v-text-field
                      v-model="MobileNo"
                      :rules="MobileNoRules"
                      :counter="10"
                      v-mask="'##########'"
                      type="number"
                      hint="10 digit mobile number"
                      dense
                      outlined
                      rounded
                      prepend-inner-icon="mdi-phone"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" v-else>
                    <label class="field-label">
                      <span class="text-danger">*</span> President Mobile Number
                    </label>
                    <v-text-field
                      v-model="Member.PrimaryMobile"
                      :rules="MobileNoRules"
                      :counter="10"
                      v-mask="'##########'"
                      type="number"
                      hint="10 digit mobile number"
                      dense
                      outlined
                      rounded
                      prepend-inner-icon="mdi-phone"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-if="!MemberFlag && LomType == 1"
                  >
                    <label class="field-label">
                      <span class="text-danger">*</span> Email Id
                    </label>
                    <v-text-field
                      v-model="EmailId"
                      :rules="EmailIdRules"
                      type="email"
                      hint="example@email.com"
                      dense
                      outlined
                      rounded
                      prepend-inner-icon="mdi-email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" v-else>
                    <label class="field-label">
                      <span class="text-danger">*</span> President Email Id
                    </label>
                    <v-text-field
                      v-model="Member.EmailId"
                      :rules="EmailIdRules"
                      type="email"
                      hint="example@email.com"
                      dense
                      outlined
                      rounded
                      prepend-inner-icon="mdi-email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span> Does the LO has GST
                      Number?
                    </label>
                    <v-select
                      :reduce="(option) => option.value"
                      :items="GstNumberFlagOptions"
                      :rules="GstNumberFlagRules"
                      v-model="GstNumberFlag"
                      required
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-file-document"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-if="GstNumberFlag == 1 && !MemberFlag && LomType == 1"
                  >
                    <label class="field-label">
                      <span class="text-danger">*</span> GST Number
                    </label>
                    <v-text-field
                      v-model="GstNumber"
                      :rules="GstNumberRules"
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-file-certificate"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-if="GstNumberFlag == 1 && MemberFlag"
                  >
                    <label class="field-label">
                      <span class="text-danger">*</span> GST Number
                    </label>
                    <v-text-field
                      v-model="Member.LomGstNumber"
                      :rules="GstNumberRules"
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-file-certificate"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card
              class="form-section mt-6 slide-up-animation delay-300"
              elevation="1"
            >
              <div class="card-bubbles-container">
                <div class="card-bubble" v-for="n in 5" :key="n"></div>
              </div>
              <v-card-title class="section-title">
                <v-icon class="section-icon-wrapper" color="#8950FC"
                  >mdi-cash-register</v-icon
                >
                Payment Details
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-6">
                <v-row wrap>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span> Paid Date
                    </label>
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          required
                          v-model="PaidDate"
                          label="Paid Date"
                          readonly
                          v-on="on"
                          validate-on-blur
                          dense
                          outlined
                          rounded
                          prepend-inner-icon="mdi-calendar-clock"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="PaidDate"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label">
                      <span class="text-danger">*</span> Transaction Type
                    </label>
                    <v-select
                      :reduce="(option) => option.value"
                      :items="TransactionTypeIdOptions"
                      :rules="TransactionTypeIdRules"
                      v-model="TransactionTypeId"
                      required
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-bank"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" v-if="TransactionTypeId != ''">
                    <label class="field-label">
                      <span class="text-danger">*</span> Payment Id / Cheque No.
                      / DD No.
                    </label>
                    <v-text-field
                      v-model="PaymentId"
                      :rules="PaymentIdRules"
                      hint="Enter transaction reference"
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-identifier"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-if="TransactionTypeId != 1 && TransactionTypeId != ''"
                  >
                    <label class="field-label">
                      <span class="text-danger">*</span> Transaction Fees
                    </label>
                    <v-text-field
                      v-model="TransactionFees"
                      :rules="TransactionFeesRules"
                      min="0"
                      type="number"
                      hint="Enter transaction fee"
                      dense
                      outlined
                      rounded
                      prepend-inner-icon="mdi-currency-inr"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row wrap>
                  <v-col align="center" cols="12" md="12">
                    <v-btn
                      @click.prevent="searchForm"
                      :loading="SearchFlag"
                      elevation="4"
                      rounded
                      large
                      class="submit-btn btn-gradient-primary white--text"
                    >
                      <v-icon left>mdi-magnify</v-icon>
                      Search
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>

          <v-container class="py-0" v-if="SearchFlag">
            <v-skeleton-loader
              v-bind="attrs"
              type="table-tbody"
            ></v-skeleton-loader>
          </v-container>

          <v-card
            class="mt-6 slide-up-animation delay-400"
            elevation="1"
            v-if="SearchResultFlag && !SearchFlag"
          >
            <div class="card-bubbles-container card-bubbles-tabs">
              <div class="card-bubble" v-for="n in 6" :key="n"></div>
            </div>
            <v-tabs
              v-model="tab"
              background-color="transparent"
              centered
              dark
              icons-and-text
              show-arrows
              class="modern-tabs custom-tabs-bg"
            >
              <v-tabs-slider class="slider-custom"></v-tabs-slider>

              <v-tab href="#tab-1" :disabled="TabDisable1" class="tab-item">
                <v-icon class="mr-2">mdi-cash-multiple</v-icon>
                Subscription
              </v-tab>

              <v-tab href="#tab-2" :disabled="TabDisable2" class="tab-item">
                <v-icon class="mr-2">mdi-alert-circle</v-icon>
                Late Fee
              </v-tab>

              <v-tab
                href="#tab-3"
                :disabled="TabDisable3"
                class="tab-item"
                v-if="TabFlag3"
              >
                <v-icon class="mr-2">mdi-star</v-icon>
                Senior Members
              </v-tab>

              <v-tab
                href="#tab-4"
                :disabled="TabDisable4"
                :class="[
                  'tab-item',
                  BalancePayment && BalancePayment.length > 0
                    ? 'tab-has-records'
                    : '',
                ]"
                v-if="BalancePaymentFlag"
              >
                <v-icon class="mr-2">mdi-wallet-outline</v-icon>
                Balance
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" class="tabs-content">
              <v-tab-item value="tab-1">
                <v-card flat class="tab-card">
                  <v-card-text class="pt-6">
                    <v-row wrap>
                      <v-col align="center" cols="12" md="12">
                        <h3 class="tab-heading">
                          <v-icon class="mr-2" color="#8950FC"
                            >mdi-cash-multiple</v-icon
                          >
                          List of Regular Subscriptions
                        </h3>
                      </v-col>
                    </v-row>
                    <v-row wrap>
                      <v-col align="center" cols="12" md="12">
                        <v-data-table
                          class="modern-table"
                          disable-sort
                          disable-filtering
                          v-model="selected"
                          :loading="SearchFlag"
                          loading-text="Loading... Please wait"
                          :headers="tableColumns1"
                          :items="rows"
                          :items-per-page="50"
                          :search="search"
                          item-key="YearwiseContributionId"
                          :single-select="false"
                          :show-select="false"
                          :hide-default-footer="true"
                          :footer-props="{
                            'items-per-page-options': [10, 20, 30, 40, 50],
                          }"
                        >
                          <template v-slot:item.FineCheckBox="{ item }">
                            <v-checkbox
                              v-if="item.FineFlag"
                              v-model="item.FinePaidFlag"
                              :label="item.FineAmountTxt"
                              color="info"
                              :value="item.FinePaidFlag"
                              hide-details
                              v-on="calculateTotal()"
                            ></v-checkbox>
                          </template>
                          <template v-slot:item.Qty="{ item }">
                            <v-text-field
                              v-model="item.Qty"
                              v-on="calculateTotal()"
                              type="number"
                              min="0"
                              :rules="QtyRules"
                              outlined
                              dense
                              class="qty-input"
                            ></v-text-field>
                          </template>
                          <template v-slot:item.SubTotal="{ item }">
                            <div class="amount-text">₹ {{ item.SubTotal }}</div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row class="mt-6">
                      <v-col align="center" cols="12" md="12">
                        <h3 class="total-amount">
                          <v-icon small color="#8950FC" class="mr-2"
                            >mdi-calculator</v-icon
                          >
                          Total Amount :
                          <span class="amount-value">₹ {{ TotalAmount1 }}</span>
                        </h3>
                        <v-btn
                          :disabled="!valid1"
                          @click.prevent="submitRegularSubscription"
                          :loading="SubmitFlag"
                          elevation="6"
                          rounded
                          large
                          class="submit-btn btn-gradient-success white--text mt-4"
                        >
                          <v-icon left>mdi-check-circle</v-icon>
                          Submit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item value="tab-2">
                <v-card flat class="tab-card">
                  <v-card-text class="pt-6">
                    <v-row wrap>
                      <v-col align="center" cols="12" md="12">
                        <h3 class="tab-heading">
                          <v-icon class="mr-2" color="#FF6B6B"
                            >mdi-alert-circle</v-icon
                          >
                          List of Late Fee Subscriptions
                        </h3>
                      </v-col>
                    </v-row>
                    <v-row wrap>
                      <v-col align="center" cols="12" md="12">
                        <v-data-table
                          class="modern-table"
                          disable-sort
                          disable-filtering
                          v-model="selected"
                          :loading="SearchFlag"
                          loading-text="Loading... Please wait"
                          :headers="tableColumns2"
                          :items="PenaltySubscription"
                          :items-per-page="50"
                          :search="search"
                          item-key="LomPaymentId"
                          :single-select="false"
                          :show-select="false"
                          :hide-default-footer="true"
                          :footer-props="{
                            'items-per-page-options': [10, 20, 30, 40, 50],
                          }"
                        >
                          <template v-slot:item.FineCheckBox="{ item }">
                            <v-checkbox
                              v-if="item.FineFlag"
                              v-model="item.FinePaidFlag"
                              :label="item.FineAmountTxt"
                              color="info"
                              :value="item.FinePaidFlag"
                              hide-details
                              v-on="calculatePenaltyTotal()"
                            ></v-checkbox>
                          </template>
                          <template v-slot:item.Qty="{ item }">
                            <v-text-field
                              v-model="item.Qty"
                              v-on="calculatePenaltyTotal()"
                              type="number"
                              min="0"
                              :rules="QtyRules"
                              outlined
                              dense
                              class="qty-input"
                            ></v-text-field>
                          </template>
                          <template v-slot:item.SubTotal="{ item }">
                            <div class="amount-text">₹ {{ item.SubTotal }}</div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row class="mt-6">
                      <v-col align="center" cols="12" md="12">
                        <h3 class="total-amount">
                          <v-icon small color="#FF6B6B" class="mr-2"
                            >mdi-calculator</v-icon
                          >
                          Total Amount :
                          <span class="amount-value">₹ {{ TotalAmount2 }}</span>
                        </h3><br />
                        <v-btn
                          :disabled="!valid1"
                          @click.prevent="submitPenaltySubscription"
                          :loading="SubmitFlag"
                          elevation="4"
                          rounded
                          large
                          class="submit-btn btn-gradient-danger white--text mt-4"
                        >
                          <v-icon left>mdi-check-circle</v-icon>
                          Submit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item value="tab-3" v-if="TabFlag3">
                <v-card flat class="tab-card" min-height="400">
                  <v-card-text
                    class="d-flex justify-center align-center flex-column py-12"
                  >
                    <v-icon size="80" color="#4ECDC4" class="mb-4"
                      >mdi-star-circle</v-icon
                    >
                    <h3 class="mb-4">Senior Members Association</h3>
                    <p class="mb-6" style="font-size: 16px; color: #666">
                      Pay subscription fees for senior member association
                      separately
                    </p>
                    <v-btn
                      href="https://seniors.jciindia.in/join-us"
                      target="_blank"
                      elevation="4"
                      rounded
                      large
                      class="submit-btn btn-gradient-primary white--text"
                    >
                      <v-icon left>mdi-open-in-new</v-icon>
                      Visit Senior Portal
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item value="tab-4" v-if="BalancePaymentFlag">
                <v-card flat class="tab-card">
                  <v-card-text class="pt-6">
                    <v-row wrap>
                      <v-col align="center" cols="12" md="12">
                        <h3 class="tab-heading">
                          <v-icon class="mr-2" color="#FFB84D"
                            >mdi-wallet-outline</v-icon
                          >
                          List of Balance Payments
                        </h3>
                      </v-col>
                    </v-row>
                    <v-row wrap>
                      <v-col align="center" cols="12" md="12">
                        <v-data-table
                          class="modern-table"
                          disable-sort
                          disable-filtering
                          v-model="selected"
                          :loading="SearchFlag"
                          loading-text="Loading... Please wait"
                          :headers="tableColumns4"
                          :items="BalancePayment"
                          :items-per-page="50"
                          :search="search"
                          item-key="LomPaymentId"
                          :single-select="false"
                          :show-select="false"
                          :hide-default-footer="true"
                          :footer-props="{
                            'items-per-page-options': [10, 20, 30, 40, 50],
                          }"
                        >
                          <template v-slot:[`item.BalanceAmountTxt`]="{ item }">
                            <div class="balance-badge">
                              {{ item.BalanceAmountTxt }}
                            </div>
                          </template>
                          <template
                            v-slot:[`item.BalanceAmountToBePaid`]="{ item }"
                          >
                            <div class="amount-text">
                              {{ item.BalanceAmountToBePaid }}
                            </div>
                          </template>
                          <template v-slot:[`item.Qty`]="{ item }">
                            <v-text-field
                              v-model.number="item.Qty"
                              @input="calculateBalanceTotal()"
                              type="number"
                              min="0"
                              outlined
                              dense
                              class="qty-input"
                            ></v-text-field>
                          </template>
                          <template v-slot:[`item.SubTotal`]="{ item }">
                            <div class="amount-text">
                              ₹ {{ getDecimalNumber(item.SubTotal, 2) }}
                            </div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row class="mt-6">
                      <v-col align="center" cols="12" md="12">
                        <h3 class="total-amount">
                          <v-icon small color="#FFB84D" class="mr-2"
                            >mdi-calculator</v-icon
                          >
                          Total Balance Amount :
                          <span class="amount-value">₹ {{ TotalAmount4 }}</span>
                        </h3>
                        <h4
                          class="text-center mt-4"
                          v-if="TotalAmount4 == 0"
                          style="color: #4ecdc4; font-weight: 600"
                        >
                          <v-icon small color="#4ECDC4" class="mr-2"
                            >mdi-check-circle</v-icon
                          >
                          No balance pending for payment
                        </h4>
                        <v-btn
                          :disabled="!valid1 || TotalAmount4 == 0"
                          @click.prevent="submitBalancePayment"
                          :loading="SubmitFlag"
                          elevation="4"
                          rounded
                          large
                          class="submit-btn btn-gradient-warning white--text mt-4"
                        >
                          <v-icon left>mdi-check-circle</v-icon>
                          Submit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-form>
        <br /><br />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      SearchResultFlag: false,
      NotesFlag: false,
      rows: [],
      tableColumns1: [],
      tableColumns2: [
        { text: "Date", value: "PaidDateTxt", width: "13%" },
        { text: "Description", value: "Description", width: "35%" },
        { text: "Late Fee", value: "FineAmountTxt", width: "13%" },
        { text: "To be paid", value: "FineNotPaid", width: "13%" },
        { text: "No of members", value: "Qty", width: "13%" },
        { text: "Sub Total", value: "SubTotal", width: "13%" },
      ],
      tableColumns4: [
        { text: "Date", value: "PaidDateTxt", width: "13%" },
        { text: "Year", value: "YearTxt", width: "10%" },
        { text: "Description", value: "Description", width: "25%" },
        { text: "Balance Amount", value: "BalanceAmountTxt", width: "13%" },
        { text: "Not Paid", value: "BalanceAmountToBePaid", width: "13%" },
        { text: "No of members", value: "Qty", width: "13%" },
        { text: "Sub Total", value: "SubTotal", width: "13%" },
      ],
      selected: [],
      search: "",

      CheckoutTableHeaders: [],

      tab: null,
      TabDisable1: false,
      TabDisable2: false,
      TabDisable3: false,
      TabDisable4: false,

      TabFlag3: false,

      TotalAmount: 0,
      Contribution: [],

      TotalAmount1: 0,
      TotalAmount2: 0,
      TotalAmount4: 0,

      Member: {},
      Order: {},
      MemberFlag: false,

      PenaltySubscription: [],
      BalancePayment: [],

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      OrderType: 1,

      LomTypeRules: [(v) => !!v || "LO Type is required"],
      LomType: "",
      LomTypeOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "New LO" },
        { value: 2, text: "Existing LO" },
      ],
      LomTypeOptionsLoading: false,

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [(v) => !!v || "LO is required"],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      StateCodeRules: [(v) => !!v || "State is required"],
      StateCode: "",
      StateCodeOptions: [],
      StateCodeOptionsLoading: false,

      DistrictCodeRules: [(v) => !!v || "District is required"],
      DistrictCode: "",
      DistrictCodeOptions: [],
      DistrictCodeOptionsLoading: false,

      CityCodeRules: [(v) => !!v || "City is required"],
      CityCode: "",
      CityCodeOptions: [],
      CityCodeOptionsLoading: false,

      MobileNo: "",
      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      MemberName: "",
      MemberNameRules: [(v) => !!v || "Member Name is required"],

      EmailId: "",
      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      QtyRules: [
        (v) => Number.isInteger(Number(v)) || "Nos is invalid",
        (v) => v >= 0 || "Number must be greater than zero",
      ],

      BalanceQtyRules: [],
      BalancePaymentFlag: true,

      GstNumberFlag: 2,
      GstNumberFlagRules: [
        (v) => !!v || "Does your LO has GST number field required",
      ],
      GstNumberFlagOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Yes" },
        { value: 2, text: "No" },
      ],

      GstNumber: "",
      GstNumberRules: [(v) => !!v || "GST number is required"],

      PaidDate: "",
      PaidDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      TransactionTypeId: "",
      TransactionTypeIdRules: [
        (v) => !!v || "Transaction type should not be empty",
      ],
      TransactionTypeIdOptions: [],
      TransactionTypeIdOptionsLoading: false,

      PaymentId: "",
      PaymentIdRules: [(v) => !!v || "Payment Id is required"],

      TransactionFees: 0,
      TransactionFeesRules: [],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
      this.getZoneCodeOptions();
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
    },
    PaidDate: function () {
      console.log("watch PaidDate");
      this.resetSubscription();
    },
    TransactionTypeIdOptions: function () {
      console.log("watch TransactionTypeIdOptions");
      this.TransactionTypeIdOptionsLoading = false;
    },
    StateCodeOptions: function () {
      console.log("watch StateCodeOptions");
      this.StateCodeOptionsLoading = false;
    },
    StateCode: function () {
      console.log("watch StateCode");
      this.getDistrictCodeOptions();
    },
    DistrictCodeOptions: function () {
      console.log("watch DistrictCodeOptions");
      this.DistrictCodeOptionsLoading = false;
    },
    DistrictCode: function () {
      console.log("watch DistrictCode");
      this.getCityCodeOptions();
    },
    CityCodeOptions: function () {
      console.log("watch CityCodeOptions");
      this.CityCodeOptionsLoading = false;
    },
    CityCode: function () {
      console.log("watch CityCode");
      console.log("CityCode" + this.CityCode);
      console.log("CityId" + this.Member.CityId);
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "membership_payment",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.StateCode = "";
      this.DistrictCode = "";
      this.CityCode = "";
      this.getJciYearCodeOptions();
      this.getStateCodeOptions();
      this.getTransactionTypeIdOptions();
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/staff/list";
      var params = {};
      this.pageRedirect(params, url);
    },
    resetForm() {
      this.$refs.form2.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    resetMember() {
      console.log("resetMember called");
      this.LomCode = "";
      this.Member = {
        MemberId: "",
        PrimaryMobile: "",
        EmailId: "",
      };
      this.MemberFlag = false;
    },
    resetSubscription() {
      this.SearchResultFlag = false;
      this.rows = [];
      this.PenaltySubscription = [];
    },
    getTransactionTypeIdOptions() {
      console.log("getTransactionTypeIdOptions called");
      this.TransactionTypeIdOptionsLoading = true;
      var selectbox1_source = "TransactionTypeId";
      var selectbox1_destination = "TransactionTypeIdOptions";
      var selectbox1_url = "api/sub-category/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        CategoryMainId: 3,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getJciYearCodeOptions() {
      console.log("getJciYearCodeOptions called");
      this.JciYearCodeOptionsLoading = true;
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        LomCode: 3,
        ZoneCode: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.resetMember();
        this.resetSubscription();
        this.ZoneCode = "";
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      console.log("YearCode=" + YearCode + ", ZoneCode=" + ZoneCode);
      if (YearCode != "" && ZoneCode != "") {
        this.resetMember();
        this.resetSubscription();
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getStateCodeOptions() {
      console.log("getStateCodeOptions called");
      var selectbox1_source = "StateCode";
      var selectbox1_destination = "StateCodeOptions";
      var selectbox1_url = "api/states/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getDistrictCodeOptions() {
      console.log("getDistrictCodeOptions called");
      this.DistrictCodeOptions = [];
      var StateCode = this.StateCode;
      console.log({ StateCode });
      if (StateCode > 0) {
        this.DistrictCodeOptionsLoading = true;
        var selectbox1_source = "DistrictCode";
        var selectbox1_destination = "DistrictCodeOptions";
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: StateCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getCityCodeOptions() {
      console.log("getCityCodeOptions called");
      this.CityCodeOptions = [];
      var DistrictCode = this.DistrictCode;
      console.log({ DistrictCode });
      if (DistrictCode > 0) {
        this.CityCodeOptionsLoading = true;
        var selectbox1_source = "CityCode";
        var selectbox1_destination = "CityCodeOptions";
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: DistrictCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    submitRegularSubscription() {
      console.log("submitRegularSubscription called");
      this.OrderType = 1;
      this.TotalAmount = this.TotalAmount1;
      this.Contribution = this.rows;
      this.confirmAlert();
    },
    submitPenaltySubscription() {
      console.log("submitPenaltySubscription called");
      this.OrderType = 2;
      this.TotalAmount = this.TotalAmount2;
      this.Contribution = this.PenaltySubscription;
      this.confirmAlert();
    },
    submitBalancePayment() {
      console.log("submitBalancePayment called");
      this.OrderType = 5;
      this.TotalAmount = this.TotalAmount4;
      this.Contribution = this.BalancePayment;
      this.confirmAlert();
    },
    calculateTotal() {
      console.log("calculateTotal called");
      var n1 = this.rows.length;
      var totalAmount = 0;
      // console.log("n1=" + n1 + ", rows=" + JSON.stringify(this.rows));
      for (var i = 0; i < n1; i++) {
        var qty = this.rows[i]["Qty"];
        var PenaltyAmount = this.rows[i]["FineAmount"];
        var WithoutFineAmount = this.rows[i]["WithoutFineAmount"];
        var FinePaidFlag = this.rows[i]["FinePaidFlag"];
        var amount = this.rows[i]["Amount"];
        console.log(
          "i=" +
            i +
            ", qty=" +
            qty +
            ", PenaltyAmount=" +
            PenaltyAmount +
            ", WithoutFineAmount=" +
            WithoutFineAmount +
            ", FinePaidFlag=" +
            FinePaidFlag +
            ", amount=" +
            amount
        );
        amount = FinePaidFlag ? amount : WithoutFineAmount;
        PenaltyAmount = FinePaidFlag ? PenaltyAmount : 0;
        console.log("amount=" + amount + ", PenaltyAmount=" + PenaltyAmount);
        qty = !isNaN(qty) ? (qty >= 0 ? qty : 0) : 0;
        amount = !isNaN(amount) ? amount : 0;
        console.log("qty=" + qty + ", amount=" + amount);
        var subTotal = parseFloat(qty) * parseFloat(amount);
        this.rows[i]["PenaltyAmount"] = PenaltyAmount;
        this.rows[i]["PenaltyAmountTxt"] = this.getDecimalNumber(
          PenaltyAmount,
          2
        );
        this.rows[i]["SubTotal"] = isNaN(subTotal)
          ? 0
          : this.getDecimalNumber(subTotal, 2);
      }
      var totalAmount = this.rows.reduce(function (sum, line) {
        var lineTotal = parseFloat(line.SubTotal);
        console.log("lineTotal=" + lineTotal);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);
      console.log("totalAmount=" + totalAmount);
      this.TotalAmount1 = isNaN(totalAmount)
        ? 0
        : this.getDecimalNumber(totalAmount, 2);
    },
    calculatePenaltyTotal() {
      console.log("calculateTotal called");
      var rows = this.PenaltySubscription;
      var n1 = rows.length;
      var totalAmount = 0;
      // console.log("n1=" + n1 + ", rows=" + JSON.stringify(this.rows));
      for (var i = 0; i < n1; i++) {
        var qty = rows[i]["Qty"];
        var amount = rows[i]["FineAmount"];
        console.log("i=" + i + ", qty=" + qty + ", amount=" + amount);
        qty = !isNaN(qty) ? (qty >= 0 ? qty : 0) : 0;
        amount = !isNaN(amount) ? amount : 0;
        console.log("qty=" + qty + ", amount=" + amount);
        var subTotal = parseFloat(qty) * parseFloat(amount);
        this.PenaltySubscription[i]["SubTotal"] = isNaN(subTotal)
          ? 0
          : this.getDecimalNumber(subTotal, 2);
      }
      var totalAmount = this.PenaltySubscription.reduce(function (sum, line) {
        var lineTotal = parseFloat(line.SubTotal);
        console.log("lineTotal=" + lineTotal);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);
      console.log("totalAmount=" + totalAmount);
      this.TotalAmount2 = isNaN(totalAmount)
        ? 0
        : this.getDecimalNumber(totalAmount, 2);
    },
    calculateBalanceTotal() {
      console.log("calculateBalanceTotal called");
      // SubTotal = BalanceAmount × Number of Members
      var rows = this.BalancePayment;
      var n1 = rows.length;
      for (var i = 0; i < n1; i++) {
        var balance = rows[i]["TotalBalanceAmount"];
        var qty = rows[i]["Qty"];
        balance = !isNaN(balance) ? (balance >= 0 ? balance : 0) : 0;
        qty = !isNaN(qty) ? (qty >= 0 ? qty : 0) : 0;
        var subTotal = parseFloat(balance) * parseFloat(qty);
        this.BalancePayment[i]["SubTotal"] = isNaN(subTotal)
          ? 0
          : this.getDecimalNumber(subTotal, 2);
        this.BalancePayment[i]["Amount"] = balance;
      }
      var totalAmount = this.BalancePayment.reduce(function (sum, line) {
        var lineTotal = parseFloat(line.SubTotal);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
        return sum;
      }, 0);
      this.TotalAmount4 = isNaN(totalAmount)
        ? 0
        : this.getDecimalNumber(totalAmount, 2);
    },
    checkout() {
      console.log("checkout");
      this.pageRedirect({}, "/members/subscription/payment/checkout");
    },

    getMemberDetails() {
      console.log("getMemberDetails called");
      this.resetSubscription();
      var temp_code = this.LomCode;
      console.log("temp_code=" + temp_code);
      var idx = this.LomCodeOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.LomCodeOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.Member = member;
        this.MemberFlag = member.MemberName != "" ? true : false;
        this.StateCode = member.LomStateId;
        this.DistrictCode = member.LomDistrictId;
        this.CityCode = member.LomCityId;
      }
    },
    getJciYearCodeOptions() {
      this.LoadingFlag = true;
      this.JciYearCodeOptionsLoading = true;
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    searchForm() {
      console.log("searchForm is called");
      var validate1 = this.$refs.form2.validate();
      var MemberId = this.Member.MemberId;
      var MemberFlag = this.MemberFlag;
      var PaidDate = this.PaidDate;
      var LomType = this.LomType;
      var MemberName = this.MemberName;
      LomType = MemberFlag ? 2 : LomType;
      this.LomType = LomType;

      console.log(
        "validate1=" +
          validate1 +
          ", MemberId=" +
          MemberId +
          ", LomType=" +
          LomType +
          ", MemberName=" +
          MemberName +
          ", PaidDate=" +
          PaidDate
      );
      if (
        validate1 &&
        PaidDate != "" &&
        ((LomType == 2 && MemberId != "") || (LomType == 1 && MemberName != ""))
      ) {
        this.getRegularSubscriptionList();
        this.getPenaltySubscriptionList();
        this.getBalanceAmountSubscriptionList();
      } else {
        var message = "";
        if (!validate1) {
          message = "Kindly fill the required fields. ";
        }
        if (LomType == 2 && MemberId == "") {
          message += "Kindly assign President for the selected LO. ";
        }
        if (LomType == 1 && MemberName == "") {
          message += "Member Name should not be empty. ";
        }
        if (PaidDate == "") {
          message += "Paid date should not be empty. ";
        }
        this.sweetAlert("error", message, false);
        // this.toast("error", message);
      }
    },
    getRegularSubscriptionList() {
      console.log("getRegularSubscriptionList is called");

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.SearchFlag = true;
        this.rows = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-contribution/lists";
        var upload = {
          UserInterface: 1,
          YearCode: this.JciYearCode,
          LomCode: this.LomCode,
          PaidDate: this.PaidDate,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.SearchResultFlag = true;
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.rows = records.TableData;
              thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            this.SearchFlag = false;
          });
      } else {
        var message = "";
        if (JciYearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getPenaltySubscriptionList() {
      console.log("getPenaltySubscriptionList is called");

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.SearchFlag = true;
        this.PenaltySubscription = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-payment/lists";
        var upload = {
          UserInterface: 2,
          LomCode: this.LomCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.SearchResultFlag = true;
              // thisIns.tableColumns1 = records.TableHeader;
              thisIns.PenaltySubscription = records;
              thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            this.SearchFlag = false;
          });
      } else {
        var message = "";
        if (LomId == "") {
          message += "LO should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getBalanceAmountSubscriptionList() {
      console.log("getBalanceAmountSubscriptionList is called");

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.SearchFlag = true;
        this.BalancePayment = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-payment/lists";
        var upload = {
          UserInterface: 4,
          LomCode: this.LomCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log("records=" + JSON.stringify(records));

            var TableContent = response.data.table_content;
            console.log({ TableContent });

            if (flag == 1) {
              thisIns.SearchResultFlag = true;
              thisIns.BalancePayment = records;
              thisIns.tableColumns4 = TableContent.TableHeader;
              thisIns.calculateBalanceTotal();
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "";
        if (LomCode == "") {
          message += "LO should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    confirmAlert() {
      var validate1 = this.$refs.form2.validate();
      var MemberId = this.Member.MemberId;
      var PaidDate = this.PaidDate;
      var LomType = this.LomType;
      var MemberName = this.MemberName;
      var TotalAmount = this.TotalAmount;
      var MemberFlag = this.MemberFlag;
      LomType = MemberFlag ? 2 : LomType;
      this.LomType = LomType;

      console.log(
        "validate1=" +
          validate1 +
          ", MemberId=" +
          MemberId +
          ", LomType=" +
          LomType +
          ", MemberName=" +
          MemberName +
          ", PaidDate=" +
          PaidDate +
          ", TotalAmount=" +
          TotalAmount
      );

      // TotalAmount=0;

      if (
        validate1 &&
        PaidDate != "" &&
        TotalAmount > 0 &&
        ((LomType == 2 && MemberId != "") || (LomType == 1 && MemberName != ""))
      ) {
        var tempContribution = this.Contribution;
        let Contribution = tempContribution.filter(function (e) {
          return e.Qty > 0;
        });
        console.log(Contribution);

        var htmlTxt = "";
        // var ContributionTxt = JSON.stringify(Contribution);

        Contribution.forEach((item) => {
          console.log("item=" + JSON.stringify(item));
          htmlTxt +=
            item["Description"] + " - <b>" + item["Qty"] + " Nos </b><br/>";
        });

        htmlTxt += "<br/>Total amount <b> Rs." + TotalAmount + "</b>";

        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalAmount == 0) {
          message += "Minimum one nos required to continue. ";
        }
        if (LomType == 2 && MemberId == "") {
          message += "Kindly assign President for the selected LO. ";
        }
        if (LomType == 1 && MemberName == "") {
          message += "Member Name should not be empty. ";
        }
        if (PaidDate == "") {
          message += "Paid date should not be empty. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form2.validate();
      var TotalAmount = this.TotalAmount;
      console.log("validate1=" + validate1 + ", TotalAmount=" + TotalAmount);

      // TotalAmount=0;

      if (validate1 && TotalAmount > 0) {
        this.SubmitFlag = true;
        this.TabDisable1 = true;
        this.TabDisable2 = true;

        // Get Year name from JciYearCodeOptions

        var JciYearCode = this.JciYearCode;
        var JciYearCodeIndex = this.JciYearCodeOptions.map(
          (e) => e.value
        ).indexOf(JciYearCode);
        console.log(
          "JciYearCode=" +
            JciYearCode +
            ", JciYearCodeIndex=" +
            JciYearCodeIndex
        );
        var JciYearName = this.JciYearCodeOptions[JciYearCodeIndex].text;
        console.log("JciYearName=" + JciYearName);

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-payment/offline";

        var upload = {
          LomType: this.LomType,
          YearCode: this.JciYearCode,
          ZoneCode: this.ZoneCode,
          LomCode: this.LomCode,
          OrderType: this.OrderType,
          YearName: JciYearName,
          LoState: this.StateCode,
          LoDistrict: this.DistrictCode,
          LoCity: this.CityCode,
          GstNumberFlag: this.GstNumberFlag,
          PaidDate: this.PaidDate,
          TransactionTypeId: this.TransactionTypeId,
          PaymentId: this.PaymentId,
          TransactionFees: this.TransactionFees,
          TotalAmount: this.TotalAmount,
          Member: this.Member,
          Contribution: this.Contribution,
        };

        var LomType = this.LomType;

        if (LomType == 1) {
          upload.MemberId = 0;
          upload.MemberName = this.MemberName;
          upload.PrimaryMobile = this.MobileNo;
          upload.EmailId = this.EmailId;
          upload.GstNumber = this.GstNumber;
        } else {
          upload.MemberId = this.Member.MemberId;
          upload.MemberName = this.Member.MemberName;
          upload.PrimaryMobile = this.Member.PrimaryMobile;
          upload.EmailId = this.Member.EmailId;
          upload.GstNumber = this.Member.LomGstNumber;
        }

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        // this.$session.set("checkout", upload);
        // this.checkout();

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.TabDisable1 = false;
            thisIns.TabDisable2 = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.resetForm();
              thisIns.resetMember();
              thisIns.resetSubscription();
              thisIns.sweetAlert("success", output, true);
            } else {
              // thisIns.toast("error", output);
              thisIns.sweetAlert("info", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.TabDisable1 = false;
            thisIns.TabDisable2 = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalAmount == 0) {
          message += "Minimum one nos required to continue. ";
        }
        this.sweetAlert("error", message, false);
        // this.toast("error", message);
      }
    },
  },
  beforeMount() {
    if (this.$session.has("checkout")) {
      this.$session.remove("checkout");
    }
    this.refreshPageData();
    /*
    this.tableColumns1.push(
      { text: "Description", value: "Description" },
      { text: "Subscription Fees", value: "AmountTxt" },
      { text: "Nos", value: "Qty" },
      { text: "Sub Total", value: "SubTotal" }
      // { text: "Actions", value: "actions" }
    );
    */
  },
};
</script>
<style lang="scss">
/* This is for documentation purposes and will not be needed in your application */
#member-subscription-create {
  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }

  // --- Modern Card Header ---
  .modern-header {
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 12px 36px rgba(48, 43, 99, 0.12) !important;
    margin-bottom: 28px;
  }

  .modern-card-title {
    // JCI Navy gradient with enhanced depth
    background: linear-gradient(135deg, #3a67b1 0%, #2a5299 100%);
    color: #ffffff;
    padding: 32px 40px;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    z-index: 1;
    min-height: 140px;

    .header-left {
      display: flex;
      align-items: center;
      gap: 24px;
      position: relative;
      z-index: 2;
    }

    .title-content {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .header-actions {
      position: relative;
      z-index: 2;
    }

    .flying-icon {
      animation: float-icon 3s ease-in-out infinite;
      filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.2));
    }

    .page-title {
      font-size: 32px;
      font-weight: 900;
      margin: 0;
      letter-spacing: -0.8px;
      text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      line-height: 1.2;
      font-family: "Roboto", "Segoe UI", sans-serif;
    }

    .page-subtitle {
      font-size: 15px;
      font-weight: 500;
      margin: 10px 0 0 0;
      opacity: 0.92;
      letter-spacing: 0.4px;
      line-height: 1.5;
      max-width: 600px;
    }

    .action-btn {
      background: rgba(255, 255, 255, 0.18);
      backdrop-filter: blur(8px);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: rgba(255, 255, 255, 0.28);
        transform: rotate(180deg) scale(1.1);
      }
    }
  }

  @keyframes float-icon {
    0%,
    100% {
      transform: translateY(0px) rotate(0deg);
    }

    25% {
      transform: translateY(-8px) rotate(-5deg);
    }

    50% {
      transform: translateY(0px) rotate(0deg);
    }

    75% {
      transform: translateY(-8px) rotate(5deg);
    }
  }

  // --- Floating Bubbles ---
  .bg-bubbles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: absolute;
      list-style: none;
      display: block;
      width: 40px;
      height: 40px;
      background: rgba(237, 190, 56, 0.18);
      border-radius: 50%;
      bottom: -160px;
      animation: bubble-float 25s infinite;
      transition-timing-function: linear;
      box-shadow: 0 4px 12px rgba(237, 190, 56, 0.2);
    }

    li:nth-child(1) {
      left: 10%;
      width: 80px;
      height: 80px;
      animation-delay: 0s;
      animation-duration: 20s;
    }

    li:nth-child(2) {
      left: 20%;
      width: 50px;
      height: 50px;
      animation-delay: 2s;
      animation-duration: 17s;
    }

    li:nth-child(3) {
      left: 35%;
      width: 60px;
      height: 60px;
      animation-delay: 4s;
      animation-duration: 22s;
    }

    li:nth-child(4) {
      left: 50%;
      width: 30px;
      height: 30px;
      animation-delay: 0s;
      animation-duration: 18s;
    }

    li:nth-child(5) {
      left: 55%;
      width: 70px;
      height: 70px;
      animation-delay: 0s;
      animation-duration: 25s;
    }

    li:nth-child(6) {
      left: 65%;
      width: 40px;
      height: 40px;
      animation-delay: 3s;
      animation-duration: 19s;
    }

    li:nth-child(7) {
      left: 75%;
      width: 90px;
      height: 90px;
      animation-delay: 7s;
      animation-duration: 23s;
    }

    li:nth-child(8) {
      left: 80%;
      width: 35px;
      height: 35px;
      animation-delay: 15s;
      animation-duration: 20s;
    }

    li:nth-child(9) {
      left: 90%;
      width: 55px;
      height: 55px;
      animation-delay: 2s;
      animation-duration: 21s;
    }

    li:nth-child(10) {
      left: 25%;
      width: 45px;
      height: 45px;
      animation-delay: 8s;
      animation-duration: 24s;
    }
  }

  @keyframes bubble-float {
    0% {
      bottom: -160px;
      transform: translateX(0);
      opacity: 0;
    }

    10% {
      opacity: 1;
    }

    90% {
      opacity: 1;
    }

    100% {
      bottom: 120%;
      transform: translateX(50px);
      opacity: 0;
    }
  }

  // --- Animations ---
  @keyframes slide-up {
    from {
      opacity: 0;
      transform: translateY(40px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .slide-up-animation {
    animation: slide-up 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .delay-100 {
    animation-delay: 0.1s;
    opacity: 0;
  }

  .delay-200 {
    animation-delay: 0.2s;
    opacity: 0;
  }

  .delay-300 {
    animation-delay: 0.3s;
    opacity: 0;
  }

  .delay-400 {
    animation-delay: 0.4s;
    opacity: 0;
  }

  // --- Form Sections ---
  .form-section {
    border-radius: 16px;
    border: 1px solid rgba(58, 103, 177, 0.15);
    background: linear-gradient(to bottom right, #ffffff, #f8fafc);
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.08);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;

    &:hover {
      box-shadow: 0 16px 40px rgba(58, 103, 177, 0.12);
      transform: translateY(-4px);
    }
  }

  .form-section-org {
    border-left: 6px solid #3a67b1;
  }

  .form-section-location {
    border-left: 6px solid #c31432;
  }

  // --- Card Bubbles ---
  .card-bubbles-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
  }

  .card-bubble {
    position: absolute;
    border-radius: 50%;
    background: radial-gradient(
      circle at 30% 40%,
      rgba(58, 103, 177, 0.12),
      rgba(0, 151, 215, 0.04)
    );
    animation: card-bubble-float 10s ease-in-out infinite;
    opacity: 0.3;
  }

  .card-bubble:nth-child(1) {
    width: 80px;
    height: 80px;
    top: 10%;
    left: 10%;
    animation-duration: 12s;
  }

  .card-bubble:nth-child(2) {
    width: 60px;
    height: 60px;
    top: 60%;
    left: 80%;
    animation-duration: 9s;
    animation-delay: 1s;
  }

  .card-bubble:nth-child(3) {
    width: 100px;
    height: 100px;
    top: 80%;
    left: 5%;
    animation-duration: 14s;
    animation-delay: 2s;
  }

  .card-bubble:nth-child(4) {
    width: 70px;
    height: 70px;
    top: 20%;
    right: 10%;
    animation-duration: 10s;
    animation-delay: 1.5s;
  }

  .card-bubble:nth-child(5) {
    width: 55px;
    height: 55px;
    top: 50%;
    right: 15%;
    animation-duration: 11s;
    animation-delay: 0.5s;
  }

  .card-bubble:nth-child(6) {
    width: 40px;
    height: 40px;
    top: 30%;
    left: 20%;
    animation-duration: 8.5s;
    animation-delay: 2.5s;
  }

  @keyframes card-bubble-float {
    0% {
      transform: translateY(0) translateX(0) scale(1);
      opacity: 0.3;
    }

    25% {
      transform: translateY(-20px) translateX(15px) scale(1.1);
      opacity: 0.5;
    }

    50% {
      transform: translateY(-40px) translateX(-10px) scale(0.9);
      opacity: 0.3;
    }

    75% {
      transform: translateY(-15px) translateX(20px) scale(1.05);
      opacity: 0.4;
    }

    100% {
      transform: translateY(0) translateX(0) scale(1);
      opacity: 0.3;
    }
  }

  .card-bubbles-tabs {
    background: linear-gradient(
      135deg,
      rgba(58, 103, 177, 0.08),
      rgba(0, 151, 215, 0.04)
    );
  }

  .section-title {
    font-size: 18px;
    font-weight: 800;
    color: #3a67b1;
    background: linear-gradient(
      to right,
      rgba(58, 103, 177, 0.05),
      rgba(0, 151, 215, 0.02)
    );
    padding: 22px 28px;
    border-bottom: 2px solid rgba(48, 43, 99, 0.12);
    display: flex;
    align-items: center;
    gap: 14px;
    letter-spacing: 0.3px;
    position: relative;
    z-index: 2;

    .section-icon-wrapper {
      background: linear-gradient(
        135deg,
        rgba(58, 103, 177, 0.15),
        rgba(0, 151, 215, 0.08)
      );
      padding: 10px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      min-height: 40px;
      box-shadow: 0 4px 12px rgba(48, 43, 99, 0.1);
      transition: all 0.3s ease;
    }

    .v-icon {
      font-size: 22px !important;
    }

    &:hover .section-icon-wrapper {
      transform: scale(1.1) rotate(5deg);
      box-shadow: 0 6px 16px rgba(48, 43, 99, 0.15);
    }
  }

  // --- Inputs ---
  .v-input__slot {
    border-radius: 10px !important;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(58, 103, 177, 0.02) !important;
    }
  }

  .v-text-field--outlined.v-input--is-focused fieldset {
    border: 2px solid #0097d7 !important;
    box-shadow: 0 0 0 4px rgba(0, 151, 215, 0.08);
  }

  .v-text-field--outlined fieldset {
    border-color: rgba(58, 103, 177, 0.2) !important;
  }

  .field-label {
    font-size: 12px;
    font-weight: 700;
    color: #3a67b1;
    margin-bottom: 10px;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.9px;
  }

  .info-text {
    font-size: 17px;
    font-weight: 800;
    color: #0a0f29;
    margin: 0 0 4px 0;
    letter-spacing: -0.3px;
  }

  .info-subtext {
    font-size: 13px;
    color: #414042;
    margin: 0;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  .member-image-small {
    border-radius: 50%;
    border: 3px solid #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  // --- Tabs ---
  .modern-tabs {
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
  }

  .custom-tabs-bg {
    // JCI Navy gradient
    background: linear-gradient(135deg, #3a67b1 0%, #2a5299 100%) !important;
  }

  .v-tab {
    font-weight: 700;
    letter-spacing: 1px;
    font-size: 14px;
    padding: 16px 24px;
    opacity: 0.7;
    transition: all 0.3s;

    &.v-tab--active {
      opacity: 1;
      background: rgba(237, 190, 56, 0.2);
      backdrop-filter: blur(5px);
      color: #ffffff !important;
    }

    &:hover {
      opacity: 1;
      background: rgba(255, 255, 255, 0.05);
    }
  }

  .tab-card {
    border-radius: 0 0 16px 16px;
    border: 1px solid rgba(58, 103, 177, 0.15);
    border-top: none;
    background: linear-gradient(to bottom right, #ffffff, #f5f8ff);
    box-shadow: 0 12px 28px rgba(58, 103, 177, 0.06);
    position: relative;
    z-index: 2;
    animation: tabCardSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  @keyframes tabCardSlideIn {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .tab-heading {
    font-size: 20px;
    font-weight: 700;
    color: #3a67b1;
    margin-bottom: 28px;
    padding: 16px 32px;
    background: linear-gradient(
      to right,
      rgba(58, 103, 177, 0.08),
      rgba(0, 151, 215, 0.03)
    );
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    border: 1px solid rgba(58, 103, 177, 0.12);
    box-shadow: 0 4px 12px rgba(58, 103, 177, 0.04);

    .v-icon {
      color: #3a67b1 !important;
    }
  }

  // --- Table ---
  .modern-table {
    border: 1px solid rgba(58, 103, 177, 0.15) !important;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 20px rgba(58, 103, 177, 0.06) !important;

    thead {
      background: linear-gradient(
        to right,
        rgba(58, 103, 177, 0.08),
        rgba(0, 151, 215, 0.04)
      );

      th {
        font-weight: 800 !important;
        color: #3a67b1 !important;
        text-transform: uppercase;
        font-size: 12px !important;
        letter-spacing: 1.1px;
        height: 65px !important;
        border-bottom: 2px solid rgba(48, 43, 99, 0.2) !important;
        padding: 14px 16px !important;
      }
    }

    tbody {
      tr {
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border-bottom: 1px solid rgba(58, 103, 177, 0.08) !important;

        &:hover {
          background-color: rgba(58, 103, 177, 0.04) !important;
          box-shadow: 0 4px 12px rgba(58, 103, 177, 0.08) inset;
        }

        &:last-child {
          border-bottom: none !important;
        }
      }

      td {
        font-size: 14px !important;
        color: #414042;
        height: 68px !important;
        padding: 14px 16px !important;
        font-weight: 500;
      }
    }
  }

  .qty-input {
    max-width: 100px;
    margin: 0 auto;

    input {
      text-align: center;
      font-weight: 700;
      font-size: 16px;
      color: #2d3748;
    }
  }

  .amount-text {
    font-weight: 800;
    color: #0a0f29;
    font-family: "IBM Plex Mono", "Roboto Mono", monospace;
    font-size: 15px;
    background: rgba(58, 103, 177, 0.05);
    padding: 6px 10px;
    border-radius: 6px;
    letter-spacing: 0.3px;
  }

  // --- Total & Submit ---
  .total-amount {
    font-size: 20px;
    font-weight: 700;
    color: #0a0f29;
    padding: 26px 42px;
    background: linear-gradient(
      to right,
      rgba(58, 103, 177, 0.06),
      rgba(237, 190, 56, 0.02)
    );
    border: 2px solid rgba(58, 103, 177, 0.15);
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 8px 20px rgba(58, 103, 177, 0.06);

    .v-icon {
      color: #3a67b1;
    }

    .amount-value {
      font-size: 34px;
      font-weight: 900;
      background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "IBM Plex Mono", "Roboto Mono", monospace;
      letter-spacing: 1px;
    }
  }

  .submit-btn {
    font-weight: 800;
    letter-spacing: 1px;
    text-transform: uppercase;
    min-width: 280px;
    height: 56px !important;
    border-radius: 12px;
    background: linear-gradient(135deg, #56bda3 0%, #0097d7 100%) !important;
    box-shadow: 0 8px 20px rgba(58, 103, 177, 0.25);
    color: #ffffff !important;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    animation: pulse-glow-header 3s infinite;

    &:hover {
      transform: translateY(-4px) scale(1.02);
      box-shadow: 0 16px 36px rgba(58, 103, 177, 0.35);
    }

    &:disabled {
      box-shadow: none;
      animation: none;
      opacity: 0.7;
      background: #cbd5e0 !important;
      color: #718096 !important;
    }
  }

  @keyframes pulse-glow-header {
    0% {
      box-shadow: 0 8px 20px rgba(58, 103, 177, 0.25);
    }

    70% {
      box-shadow: 0 8px 20px rgba(58, 103, 177, 0.4);
    }

    100% {
      box-shadow: 0 8px 20px rgba(58, 103, 177, 0.25);
    }
  }

  .btn-gradient-success {
    background: linear-gradient(135deg, #00b09b 0%, #016e62 100%) !important;
  }

  .btn-gradient-danger {
    background: linear-gradient(135deg, #ff6b6b 0%, #fd3838 100%) !important;
  }

  .btn-gradient-warning {
    background: linear-gradient(135deg, #1f1403 0%, #ffa500 100%) !important;
  }

  .btn-gradient-primary {
    background: linear-gradient(135deg, #8fe0cc 0%, #0099ff 100%) !important;
  }

  // --- Badges ---
  .balance-badge {
    background: #fff3e0;
    color: #f57c00;
    padding: 8px 16px;
    border-radius: 30px;
    font-weight: 800;
    font-size: 14px;
    display: inline-block;
    border: 1px solid #ffe0b2;
    box-shadow: 0 4px 10px rgba(245, 124, 0, 0.15);
  }

  .status-chip {
    font-weight: 700;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  /* Tab Indicator Styles */
  @keyframes tab-blink {
    0%,
    49% {
      opacity: 1;
      box-shadow: 0 0 0 3px rgba(237, 190, 56, 0.6);
    }
    50%,
    100% {
      opacity: 0.3;
      box-shadow: 0 0 0 3px rgba(237, 190, 56, 0.3);
    }
  }

  .tab-has-records {
    position: relative;

    &::after {
      content: "●";
      position: absolute;
      right: 8px;
      top: 4px;
      font-size: 10px;
      color: #edbe38;
      animation: tab-blink 1.5s infinite;
      font-weight: bold;
    }
  }

  // --- Notes ---
  .modern-notes {
    background: linear-gradient(
      to right,
      rgba(195, 20, 50, 0.05),
      rgba(195, 20, 50, 0.02)
    );
    backdrop-filter: blur(5px);
    border: 1px solid rgba(195, 20, 50, 0.2);
    border-left: 5px solid #c31432;
    border-radius: 12px;
    padding: 24px 28px;
    margin-bottom: 28px;
    box-shadow: 0 4px 16px rgba(195, 20, 50, 0.08);

    .notes-title {
      font-weight: 800;
      color: #c31432;
      font-size: 15px;
      margin-bottom: 14px;
      display: inline-block;
      text-transform: uppercase;
      letter-spacing: 0.6px;
    }

    .v-icon {
      color: #c31432 !important;
    }

    .notes-list li .v-icon {
      color: #302b63 !important;
    }
  }

  // --- Required Field Indicator ---
  .required-pill {
    display: inline-flex;
    align-items: center;
    background: linear-gradient(
      to right,
      rgba(48, 43, 99, 0.06),
      rgba(48, 43, 99, 0.02)
    );
    padding: 10px 26px;
    border-radius: 50px;
    box-shadow: 0 4px 12px rgba(15, 12, 41, 0.08);
    border: 1px solid rgba(48, 43, 99, 0.2);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 18px rgba(15, 12, 41, 0.12);
      border-color: rgba(48, 43, 99, 0.35);
      background: linear-gradient(
        to right,
        rgba(48, 43, 99, 0.08),
        rgba(48, 43, 99, 0.04)
      );
    }

    .required-star {
      color: #c31432;
      font-size: 24px;
      line-height: 0;
      margin-right: 8px;
      margin-top: 6px;
      font-weight: bold;
      animation: pulse-red 2s infinite;
    }

    .required-text {
      font-size: 11px;
      font-weight: 700;
      color: #302b63;
      letter-spacing: 0.6px;
      text-transform: uppercase;
    }
  }

  @keyframes pulse-red {
    0% {
      transform: scale(1);
      opacity: 1;
    }

    50% {
      transform: scale(1.2);
      opacity: 0.8;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
}
</style>